/* esm.sh - applesauce-core@5.2.0/dist/observable/relay-selection */
export * from "/*applesauce-core@5.2.0/esnext/dist/observable/relay-selection.mjs";
